import React from 'react'
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom'

import ApplicationScreenWrapper from './application/ApplicationScreenWrapper'
import LoadingScreen from './application/loading/LoadingScreen'
import { RouterContext } from './contexts'
import { origins } from './constants'
import { useApplicationVariantKey } from './application/hooks/useApplicationVariants'
import { withTracker } from './ga'

// Player
const LazyPlayerContainer = React.lazy(() =>
  import('./application/player/PlayerContainer'),
)

// Greetings
const LazyGreetingsContainer = React.lazy(() =>
  import('./application/greetings/GreetingsContainer'),
)

// Project
const LazyRegistrationProjectContainer = React.lazy(() =>
  import('./application/variants/project/registration/RegistrationContainer'),
)

// Step 2
const LazyStep2GreetingsContainer = React.lazy(() =>
  import('./application/variants/step2/greetings/GreetingsContainer'),
)
const LazyRegistrationStep2Container = React.lazy(() =>
  import('./application/variants/step2/registration/RegistrationContainer'),
)

const ApplicationRouterContextProvider = withRouter(
  ({ children, ...routerProps }) => (
    <RouterContext.Provider value={routerProps}>
      {children}
    </RouterContext.Provider>
  ),
)

// Voting
const LazyVotingRoute = React.lazy(() =>
  import('./application/voting/VotingRoute'),
)

// Step 3 - Voting
const LazyStep3VotingRoute = React.lazy(() =>
  import('./application/step3voting/VotingRoute'),
)

// Step 4 - Voting
const LazyStep4VotingRoute = React.lazy(() =>
  import('./application/step4voting/VotingRoute'),
)

function onRouterUpdate() {
  /* global document */
  const main = document.querySelector('main')
  if (main && typeof main.scrollTo === 'function') {
    main.scrollTo(0, 0)
  }
}

export default function ApplicationRouter() {
  const registrationProject = useApplicationVariantKey(
    origins.projectOriginIdentifier,
    'isRegistrationOpen',
  )

  return (
    <BrowserRouter onUpdate={onRouterUpdate}>
      <ApplicationRouterContextProvider>
        <React.Suspense fallback={<LoadingScreen />}>
          <ApplicationScreenWrapper>
            <Switch>
              <Route
                component={withTracker(LazyPlayerContainer)}
                path="/player/:id"
              />

              {registrationProject && (
                <Route path="/projeto">
                  <Switch>
                    <Route
                      exact
                      path="/projeto/cadastro"
                      component={withTracker(LazyRegistrationProjectContainer)}
                    />
                  </Switch>
                </Route>
              )}

              <Route path="/etapa-2">
                <Switch>
                  <Route
                    exact
                    path="/etapa-2/cadastro"
                    component={withTracker(LazyRegistrationStep2Container)}
                  />
                  <Route component={withTracker(LazyStep2GreetingsContainer)} />
                </Switch>
              </Route>

              <Route
                exact
                path="/votacao/:team"
                component={withTracker(LazyVotingRoute)}
              />

              <Route
                path="/fase-3/votacao/:team"
                component={withTracker(LazyStep3VotingRoute)}
              />

              <Route
                path="/fase-4/votacao/:team"
                component={withTracker(LazyStep4VotingRoute)}
              />

              <Route component={withTracker(LazyGreetingsContainer)} />
            </Switch>
          </ApplicationScreenWrapper>
        </React.Suspense>
      </ApplicationRouterContextProvider>
    </BrowserRouter>
  )
}
